import React from 'react';
import PaymentManagementPage from './PaymentManagementPage';

const PaymentManagementContainer = () => {
  return <PaymentManagementPage />;
};

export default PaymentManagementContainer;
